module.exports = __webpack_public_path__ + "static/media/jenkins-icon.ebece0bd.png";